import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { defaultComponentConfig } from '@widgets/LogoutModal/types/config';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { useCallback, useMemo, useState } from 'preact/compat';
import API from '@widgets/shared/API/connection';
import FormNotices from '@widgets/shared/components/FormNotices';
import { ButtonWrapper, Copy, Title } from '@widgets/LogoutModal/styles';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
export function Modal(props) {
    const { title, successUrl, signOutButtonText, copy, goBackButtonText, } = props;
    const [logoutAllSessions, setLogoutAllSessions] = useState(false);
    const [isRequesting, setIsRequesting] = useState(false);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const onLogoutOpen = useGlobalEvent('logout.open');
    onLogoutOpen((e) => {
        setLogoutAllSessions(e.detail);
    });
    const logout = useCallback(() => {
        setIsRequesting(true);
        API.logout(logoutAllSessions).then((res) => {
            if (res.success) {
                window.location.href = res.successUrl ?? successUrl ?? '';
            }
            else if (res.message) {
                setErrorMessage(res.message);
            }
        })
            .finally(() => {
            setIsRequesting(false);
        });
    }, [logoutAllSessions]);
    const handleNoticeClose = useCallback(() => {
        setErrorMessage(undefined);
    }, []);
    return (_jsxs(_Fragment, { children: [errorMessage && (_jsx("div", { style: { marginBottom: '1rem' }, children: _jsx(FormNotices, { message: errorMessage, type: "error", handleClose: handleNoticeClose }) })), _jsx(Title, { className: "modal__title h3", children: title }), _jsx(Copy, { className: "modal__copy p", children: copy }), _jsxs(ButtonWrapper, { children: [_jsx("button", { className: "btn btn--outline", onClick: () => {
                            window.dispatchEvent(new CustomEvent('logout.closed'));
                        }, disabled: isRequesting, children: goBackButtonText }), _jsx("button", { className: "btn btn--primary", disabled: isRequesting, onClick: logout, children: signOutButtonText })] })] }));
}
function LogoutModal(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formConfig = useMemo(() => ({
        ...defaultComponentConfig,
        ...formattedAttributes,
    }), [formattedAttributes]);
    return _jsx(Modal, { ...formConfig });
}
export default LogoutModal;
